import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const EditLeadSkeleton: React.FC = () => (
  <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm">
    <Skeleton width={150} height={24} className="mb-4" />
    <div className="space-y-4">
      {[...Array(7)].map((_, i) => (
        <Skeleton key={i} height={32} />
      ))}
      <details className="bg-gray-100 p-4 rounded-lg">
        <summary>
          <Skeleton width={100} height={18} />
        </summary>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-3">
          {[...Array(5)].map((_, i) => (
            <Skeleton key={i} height={32} />
          ))}
        </div>
      </details>
      <div className="flex gap-2 justify-end mt-4">
        <Skeleton width={100} height={32} />
        <Skeleton width={80} height={32} />
      </div>
    </div>
  </div>
);

const RemarksSkeleton: React.FC = () => (
  <div className="bg-white rounded-lg border border-gray-200 max-h-[80vh] overflow-hidden shadow-sm">
    <div className="bg-gray-50 px-6 py-4 border-b border-gray-200">
      <Skeleton width={120} height={20} />
    </div>
    <div className="p-4 h-[calc(100%-280px)] overflow-y-auto space-y-4">
      {[...Array(3)].map((_, i) => (
        <div key={i} className="animate-pulse space-y-2">
          <Skeleton width={100} height={16} />
          <Skeleton height={24} />
        </div>
      ))}
    </div>
    <div className="p-4 border-t border-gray-200 bg-gray-50">
      <Skeleton height={32} className="mb-4" />
      <div className="grid grid-cols-2 gap-4 mb-2">
        <Skeleton circle width={20} height={20} />
        <Skeleton circle width={20} height={20} />
      </div>
      <Skeleton height={20} width={120} className="mb-4" />
      <div className="flex items-center gap-4">
        <Skeleton circle width={20} height={20} />
        <Skeleton width={60} height={20} />
        <Skeleton circle width={20} height={20} />
        <Skeleton width={60} height={20} />
      </div>
    </div>
  </div>
);

const TelecallerBoardSkeleton: React.FC = () => (
  <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 p-4 md:p-6">
    <div className="w-full flex flex-col lg:flex-row gap-6">
      <div className="flex-1">
        <EditLeadSkeleton />
      </div>
      <div className="w-full lg:w-96">
        <RemarksSkeleton />
      </div>
    </div>
  </div>
);

export default TelecallerBoardSkeleton;
